var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappImagePortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2895_7844)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9934 9.88086C43.7637 9.88086 12.677 40.7329 12.677 78.6607C12.677 93.701 17.5787 107.646 25.8785 118.986L17.221 144.523L43.8532 136.061C54.7967 143.243 67.9032 147.429 81.9934 147.429C120.206 147.429 151.304 116.577 151.304 78.6551C151.304 40.7329 120.206 9.88086 81.9934 9.88086Z",
    fill: "url(#paint0_linear_2895_7844)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.135 78.0752C160.135 121.111 124.968 156.01 81.591 156.01C67.8138 156.01 54.8749 152.494 43.624 146.313L0.13501 160.135L14.309 118.322C7.15496 106.574 3.04136 92.8025 3.04136 78.0808C3.04136 35.0277 38.2082 0.134766 81.591 0.134766C124.974 0.134766 160.135 35.0277 160.135 78.0752ZM81.591 12.5482C45.1666 12.5482 15.5498 41.9415 15.5498 78.0752C15.5498 92.4057 20.2168 105.685 28.1254 116.495L19.8814 140.824L45.2561 132.765C55.6798 139.606 68.1715 143.597 81.591 143.597C117.999 143.597 147.627 114.203 147.627 78.0752C147.627 41.947 117.999 12.5482 81.591 12.5482ZM121.251 96.0275C120.765 95.2282 119.48 94.7531 117.563 93.7974C115.634 92.8417 106.166 88.2194 104.4 87.5823C102.64 86.9451 101.343 86.6265 100.069 88.538C98.7831 90.4495 95.0943 94.7531 93.9653 96.0275C92.8475 97.3074 91.7241 97.4583 89.8014 96.5025C87.8732 95.5468 81.6636 93.5235 74.3139 87.0234C68.5963 81.954 64.7286 75.7054 63.5996 73.7939C62.4818 71.8824 63.4878 70.854 64.4435 69.8983C65.3098 69.0376 66.3718 67.6682 67.3331 66.556C68.3 65.4381 68.6186 64.6333 69.2614 63.359C69.9041 62.0847 69.5855 60.9724 69.0993 60.0167C68.6242 59.061 64.7677 49.66 63.1636 45.8315C61.5707 42.0141 59.961 42.1538 58.832 42.1538C57.703 42.1538 55.6351 42.4892 55.6351 42.4892C55.6351 42.4892 51.773 42.9643 50.0124 44.8757C48.2518 46.7872 43.2775 51.4094 43.2775 60.8048C43.2775 70.2001 50.1689 79.2936 51.1358 80.5623C52.1027 81.8422 64.4491 101.762 84.0278 109.408C103.601 117.054 103.601 114.505 107.133 114.181C110.66 113.868 118.524 109.564 120.128 105.099C121.732 100.638 121.732 96.8099 121.257 96.0163L121.251 96.0275Z",
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2895_7844",
    x1: 81.9934,
    y1: 9.88086,
    x2: 81.9934,
    y2: 147.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AC14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06853A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2895_7844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white",
    transform: "translate(0.13501 0.134766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappImagePortal);
export default __webpack_public_path__ + "static/media/whatsappImagePortal.834264e5c5650a2306aac3788691d02e.svg";
export { ForwardRef as ReactComponent };